<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Group" :required="true">
              <b-form-select
                @blur="$v.catalogueItem.product_group_id.$touch"
                :class="{
                  'is-invalid': $v.catalogueItem.product_group_id.$error,
                }"
                v-model="catalogueItem.product_group_id"
                :options="productGroups"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.catalogueItem.product_group_id.required"
              >
                Please select group
              </div>
            </form-group>
            <form-group label="Supplier" :required="true">
              <b-form-select
                @blur="$v.catalogueItem.supplier_id.$touch"
                :class="{ 'is-invalid': $v.catalogueItem.supplier_id.$error }"
                v-model="catalogueItem.supplier_id"
                :options="suppliers"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.catalogueItem.supplier_id.required"
              >
                Please select supplier
              </div>
            </form-group>
            <form-group label="Brand" :required="true">
              <b-form-select
                @blur="$v.catalogueItem.brand_id.$touch"
                :class="{ 'is-invalid': $v.catalogueItem.brand_id.$error }"
                v-model="catalogueItem.brand_id"
                :options="brands"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.catalogueItem.brand_id.required"
              >
                Please select brand
              </div>
            </form-group>

            <form-group label="Active">
              <b-form-checkbox
                v-model="catalogueItem.is_active"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="Name" :required="true">
              <input
                @blur="$v.catalogueItem.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.catalogueItem.name.$error }"
                v-model="catalogueItem.name"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.catalogueItem.name.required"
              >
                Please enter name
              </div>
            </form-group>

            <form-group label="Description">
              <textarea-autosize
                class="form-control"
                v-model="catalogueItem.description"
              />
            </form-group>

            <form-group label="Cooking Instructions">
              <textarea-autosize
                class="form-control"
                v-model="catalogueItem.cooking_instructions"
              />
            </form-group>

            <form-group label="Flavours">
              <input
                type="text"
                class="form-control"
                v-model="catalogueItem.flavours"
              />
            </form-group>

            <form-group label="Portion Size">
              <input
                type="text"
                class="form-control"
                v-model="catalogueItem.portion_size"
              />
            </form-group>

            <form-group label="Portions Per Pack">
              <input
                type="text"
                class="form-control"
                v-model="catalogueItem.portions_per_pack"
              />
            </form-group>

            <form-group label="Case Size">
              <input
                type="text"
                class="form-control"
                v-model="catalogueItem.case_size"
              />
            </form-group>

            <form-group label="Promote">
              <b-form-checkbox
                v-model="catalogueItem.on_promotion"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="Promotion Description">
              <textarea-autosize
                class="form-control"
                v-model="catalogueItem.promotion_description"
              />
            </form-group>

            <form-group label="Precooked">
              <b-form-checkbox
                v-model="catalogueItem.is_precooked"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="Deep Fry">
              <b-form-checkbox
                v-model="catalogueItem.can_deep_fry"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="Bake">
              <b-form-checkbox
                v-model="catalogueItem.can_bake"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="No Hormones">
              <b-form-checkbox
                v-model="catalogueItem.no_hormones"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="No Antibiotics">
              <b-form-checkbox
                v-model="catalogueItem.no_antibiotics"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="No Animal By-Products">
              <b-form-checkbox
                v-model="catalogueItem.no_animal_by_products"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import catalogueRepo from "@/api/repos/catalogueRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    catalogueItem: {
      name: {
        required,
      },
      product_group_id: {
        required,
      },
      brand_id: {
        required,
      },
      supplier_id: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      catalogueItem: {
        is_active: 1,
        is_precooked: 1,
      },
      productGroups: [],
      brands: [],
      suppliers: [],
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await catalogueRepo.createGetData();
        this.productGroups = data.product_groups;
        this.suppliers = data.suppliers;
        this.brands = data.brands;
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();

      try {
        await catalogueRepo.create(this.catalogueItem);
        this.$emit("catalogueItemCreated");
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.loading = false;
        this.submitStatus = null;
      }
    },
  },
};
</script>

